<template>
  <div class="py-3">
    <div class="d-flex align-items-center justify-content-between flex-wrap mb-3" style="gap:10px;">
      <h4 class="text-primary mb-0" style="font-weight:600;">Banking</h4>
      <a href="/chart-of-accounts" class="btn btn-primary">
        <i class="bi bi-plus-circle mr-1"></i>Add a new account
      </a>
    </div>

    <div v-if="loading" class="text-center text-secondary py-5">
      <span class="spinner-border spinner-border-sm mr-2"></span>Loading…
    </div>

    <div v-else-if="accounts.length === 0" class="bg-white border text-center py-5" style="border-radius:10px;">
      <p class="text-secondary mb-3">No cash or bank accounts yet.</p>
      <a href="/chart-of-accounts" class="btn btn-primary">Add your first account</a>
    </div>

    <div v-else class="row">
      <div class="col-12 col-md-6 col-lg-4 mb-3" v-for="account in accounts" :key="account.id">
        <div class="bg-white border h-100" style="border-radius:10px;padding:20px;">
          <p class="text-secondary mb-1" style="font-size:12px;">Cash and Bank</p>
          <p class="text-dark font-weight-bold mb-2" style="font-size:16px;">{{ account.name }}</p>
          <p class="text-dark mb-3" style="font-size:20px;font-weight:700;">{{ formatCurrency(account.calculated_balance) }}</p>
          <a :href="'/transactions?account_id=' + account.id" class="btn btn-sm btn-light">
            <i class="bi bi-list-ul mr-1"></i>View transactions
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Banking',

  data() {
    return {
      loading: true,
      accounts: [],
    };
  },

  mounted() {
    this.fetchAccounts();
  },

  methods: {
    formatCurrency(v) {
      return 'KES ' + Number(v || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },

    async fetchAccounts() {
      this.loading = true;
      try {
        const { data } = await axios.get('/api/ledger/accounts');
        this.accounts = data;
      } catch (_) {
        this.accounts = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
